
export default {
    render: function(def, ctx, callback) {
        callback();
    },
    preRender: function(def, ctx, callback) {
        //Capture this information and store it to the context location so it can be rendered on report finalization...EK
        ctx.rootContext.pageLabels.push({
            page: ctx.rootContext.pdf.internal.getCurrentPageInfo().pageNumber,
            labelDef: def,
            topPtr: ctx.rootContext.ptr.top,
            leftPtr: ctx.rootContext.ptr.left
        });

        callback();
    }
};
